import { bootstrap, isTestSeamAllowed, TEST_HOOK_KEY, type TestOverrides } from "./bootstrap.js";
import "./styles.css";

/**
 * Production entry point.
 *
 * The test seam is read here, once, and only honoured when
 * `isTestSeamAllowed` says so. In a production build that function is
 * statically false because `import.meta.env.MODE` is replaced by Vite.
 */
const seamAllowed = isTestSeamAllowed(import.meta.env.MODE, window.location.search);
const overrides = seamAllowed
  ? ((window as unknown as Record<string, unknown>)[TEST_HOOK_KEY] as TestOverrides | undefined)
  : undefined;

void bootstrap({
  document,
  window,
  overrides,
  seamAllowed,
}).catch((error: unknown) => {
  console.error("station failed to start", error);
  const status = document.querySelector<HTMLElement>("#status");
  const statusText = document.querySelector("#status-text");
  if (status) status.dataset.state = "error";
  if (statusText) statusText.textContent = "The station could not start";
});
